<template lang="pug">
  extends ../tool/CommonDetail.pug
  block detail
    ListPLCVariables(:parent_id="this.$route.params.id" @success="success" @error="error")
</template>
 
<script>
  import CommonDetail from "../tool/CommonDetail.js"
  
  import {Model, EditDialog} from "./imports.js"

  import ListPLCVariables from "../plcvariable/ListPLCVariables.vue"

  export default {
    extends: CommonDetail,
    components: {
       ListPLCVariables, Infos: EditDialog
    },
    props: {
    },
    computed: {
    },
    watch: {
    }, 
    data: () => ({
    }),

    methods: {
      loadModel () {
        this.model = new Model()
      },
    },
  }

</script>
